<template>
    <footer class="px-4 py-6">
        <p class="block text-xs text-center">
            &copy; {{ year }} - Touchstone IQ
            <span role="presentation">|</span>
            <a class="hover:underline" href="https://www.touchstoneiq.com/terms-of-use" target="_blank">
                Terms of Use
            </a>
            <span role="presentation">|</span>
            <a class="hover:underline" href="https://www.touchstoneiq.com/privacy-policy" target="_blank">
                Privacy Policy
            </a>
        </p>
    </footer>
</template>
<script>
export default {
    computed: {
        year() {
            return new Date().getFullYear();
        }
    }
};
</script>
